import { useEffect, useRef } from 'react'

export default function useMetadataTitle(title?: string) {
  const originalTitle = useRef(document.title)

  useEffect(() => {
    if (!title) return

    if (document.title !== title) document.title = title

    return () => {
      document.title = originalTitle.current
    }
  }, [title])
}
